const eventFormLivestreamFieldsStyles = (theme) => ({
  loadSetupsButton: {
    padding: '0 8px',
    [theme.breakpoints.down(1080)]: {
      paddingLeft: 0,
    },
  },
  toggleGroup: { marginLeft: 12 },
  divider: {
    width: '100%',
  },
})

export default eventFormLivestreamFieldsStyles
